/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_No_EncryptionInputs */

const en_ai_no_encryption = /** @type {(inputs: Ai_No_EncryptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keys can't be saved: SETTINGS_ENCRYPTION_KEY isn't set on the server.`)
};

const de_ai_no_encryption = /** @type {(inputs: Ai_No_EncryptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel können nicht gespeichert werden: SETTINGS_ENCRYPTION_KEY fehlt auf dem Server.`)
};

/**
* | output |
* | --- |
* | "Keys can't be saved: SETTINGS_ENCRYPTION_KEY isn't set on the server." |
*
* @param {Ai_No_EncryptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_no_encryption = /** @type {((inputs?: Ai_No_EncryptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_No_EncryptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_no_encryption(inputs)
	return en_ai_no_encryption(inputs)
});